import { render, staticRenderFns } from "./PopupDashboardsModules.vue?vue&type=template&id=3fd3fed2&scoped=true"
import script from "./PopupDashboardsModules.vue?vue&type=script&lang=js"
export * from "./PopupDashboardsModules.vue?vue&type=script&lang=js"
import style0 from "./PopupDashboardsModules.vue?vue&type=style&index=0&id=3fd3fed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd3fed2",
  null
  
)

export default component.exports